import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { FieldLabel, inputCls } from "@/components/admin/ui";

export default function AdminLogin() {
  const { user, login, ensure } = useAuth();
  useEffect(() => {
    ensure();
  }, [ensure]);
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={loc.state?.from || "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      nav(loc.state?.from || "/admin", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    }
    setLoading(false);
  };

  return (
    <div
      className="admin min-h-screen flex items-center justify-center px-4"
      data-testid="admin-login-page"
      data-admin-theme="midnight"
      data-admin-background="solid"
      data-admin-glass="false"
    >
      <form onSubmit={submit} className="admin-card w-full max-w-sm p-8">
        <p className="font-bold tracking-tight">SPICY<span className="text-[#e11d2a]">3D</span> WORLD</p>
        <h1 className="text-xl font-bold mt-6">Log in to your store</h1>
        <p className="text-sm text-zinc-500 mt-1">Owner access only.</p>
        <label className="block mt-6">
          <FieldLabel>Email</FieldLabel>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email-input" autoComplete="username" />
        </label>
        <label className="block mt-4">
          <FieldLabel>Password</FieldLabel>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password-input" autoComplete="current-password" />
        </label>
        {error && <p className="text-sm text-red-600 mt-3" data-testid="login-error">{error}</p>}
        <button disabled={loading} className="w-full mt-6 h-10 rounded-lg bg-zinc-950 text-white text-sm font-medium hover:bg-zinc-800 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit-button">
          {loading && <Loader2 size={15} className="animate-spin" />} Log in
        </button>
      </form>
    </div>
  );
}
